import { render } from "./Parcerias.vue?vue&type=template&id=5048c980&scoped=true"
import script from "./Parcerias.vue?vue&type=script&lang=js"
export * from "./Parcerias.vue?vue&type=script&lang=js"

import "./Parcerias.vue?vue&type=style&index=0&id=5048c980&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5048c980"]])

export default __exports__